import { type Mapper } from '@coris-ts/repository/mapper/mapper'
import { type ChurnItemEntity } from '../../data/entities/churn.entity'
import { type ChurnData, type ChurnResponse, type ChurnSummary } from '../models/churn'
import { DataType } from '../models/mrr'

export class ChurnEntityToChurnResponseMapper implements Mapper<ChurnItemEntity[], ChurnResponse> {
  public map(from: ChurnItemEntity[]): ChurnResponse {
    const data: ChurnData[] = from.map((item) => ({
      date: item.date,
      data_type: item.data_type === 'economics' ? DataType.Economics : DataType.Users,
      totalChurn: item.total,
      churnRate: item.rate,
      // Older backends do not send the split; treat it as absent rather than NaN.
      annualChurn: item.total_yearly ?? 0,
      monthlyChurn: item.total_monthly ?? 0
    }))

    const currentMonth = data.length > 0 ? data[data.length - 1] : null
    const summary: ChurnSummary = {
      churnRate: currentMonth?.churnRate ?? 0,
      totalChurn: currentMonth?.totalChurn ?? 0
    }

    const dataType = from[0]?.data_type === 'economics' ? DataType.Economics : DataType.Users

    return {
      data,
      summary,
      dataType
    }
  }
}
